import { useEffect } from 'react';
import useApi from './useApi';
import useApiEndpoints from '../context/useApiEndpoints';
import { ReportComment } from '../types/ViewModel/Verification/ReportComment';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, postApiData } = useApi();

    useEffect(() => {
        processApiEndpointError(state);
    }, [state]);

    const upsertReportComment = async (reportComment: ReportComment) =>
        await postApiData({
            endpoint: apiEndpoints['upsertComment'].url,
            data: reportComment,
        });

    return {
        upsertReportComment,
    };
};
